import React, { useMemo, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import { copyToClipboard } from "../../api/helper";

export default function SecretSantaLockersInfoDialog({ open, onClose, locationName, data }) {
  const isEmpty = data == null || (Array.isArray(data) && data.length === 0);
  const [copied, setCopied] = useState(false);
  const jsonText = useMemo(() => (isEmpty ? '' : JSON.stringify(data, null, 2)), [isEmpty, data]);

  const handleCopyToClipboard = () => {
    copyToClipboard(jsonText)
      .then(() => {
          setCopied(true);
          window.setTimeout(() => setCopied(false), 1500);
        }
      );
  };

  const downloadJson = () => {
    if (!jsonText) return;
    try {
      const sanitize = (s) => (s || 'location').toString().replace(/[^a-z0-9-_]+/gi, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
      const pad = (n) => String(n).padStart(2, '0');
      const d = new Date();
      const timestamp = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
      const fname = `lockers-info_${sanitize(locationName)}_${timestamp}.json`;
      const blob = new Blob([jsonText], { type: 'application/json;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fname;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      // silent fail per simple requirement
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Lockers info for {locationName}</DialogTitle>
      <DialogContent dividers>
        {isEmpty ? (
          <div>No lockers info found.</div>
        ) : (
          <pre style={{
            background: '#f5f5f5',
            padding: 12,
            borderRadius: 4,
            overflow: 'auto',
            maxHeight: 400,
            margin: 0,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
          }}>
              {jsonText}
          </pre>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={downloadJson} color="secondary" startIcon={<DownloadIcon />} disabled={isEmpty}>
          Download
        </Button>
        <Button onClick={handleCopyToClipboard} color="secondary" startIcon={<ContentCopyIcon />} disabled={isEmpty}>
          {copied ? 'Copied' : 'Copy'}
        </Button>
        <Button onClick={onClose} color="primary" variant="contained">Close</Button>
      </DialogActions>
    </Dialog>
  );
}
